import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFLookupInput } from "../../../Shared/NewForms/NFLookupInput";
import { EnumHelper } from "../../../../helpers/EnumHelper";
import { NFIntInput } from "../../../Shared/NewForms/NFIntInput";
import { useTranslation } from "react-i18next";

const WithHoldingTaxRateDetailMain = () => {
  const { t } = useTranslation();
  return (
    <>
      {" "}
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("Name")} fieldName={"name"} />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("UniqueCode")} fieldName={"uniqueCode"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupInput title={t("PaymentType")} fieldName="paymentType" items={EnumHelper.GetEnumTypeForPaymentType()} />
        </Col>
        <Col sm={6}>
          <NFDateInput title={t("CreatedDate")} fieldName={"createdDate"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFIntInput title={t("Rate")} fieldName="rate" />
        </Col>
        <Col sm={6}>
          <NFLookupInput title={t("CategoryOfIncomeReceivers")} fieldName="categoryOfIncomeReceivers" items={EnumHelper.GetEnumTypeForPaymentIncomeReceivers()} />
        </Col>
      </Row>
    </>
  );
};

export default WithHoldingTaxRateDetailMain;
